export const getSnippetSizeClasses = (
  size: string,
  type: "icon" | "text" | "badge" | "padding" | "container",
) => {
  const isSmall = size === "sm";
  const isXtraSmall = size === "xs";

  switch (type) {
    case "icon":
      if (isXtraSmall) {
        return "h-2 w-2";
      }
      if (isSmall) {
        return "h-2.5 w-2.5";
      }
      return "h-3 w-3";
    case "text":
      if (isXtraSmall) {
        return "text-[9px]";
      }
      if (isSmall) {
        return "text-[10px]";
      }
      return "text-xs";
    case "badge":
      if (isXtraSmall) {
        return "px-0.5 py-0.5 text-[8px]";
      }
      if (isSmall) {
        return "px-1 py-0.5 text-[9px]";
      }
      return "px-1.5 py-0.5 text-[10px]";
    case "padding":
      if (isXtraSmall) {
        return "p-1";
      }
      if (isSmall) {
        return "p-1.5";
      }
      return "p-2";
    case "container":
      if (isXtraSmall) {
        return "max-h-24 px-1.5 py-1";
      }
      if (isSmall) {
        return "max-h-[7.5rem] px-2 py-1.5";
      }
      return "max-h-36 px-3 py-2";
    default:
      return "";
  }
};
